export default {"src":"/_next/static/media/churro.9e371dd6.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};